import {
  IconRankAwardBlue,
  IconRankAwardBronze,
  IconRankAwardGold,
  IconRankAwardSilver,
} from "assets/svg";
import React from "react";

const rankIcons = {
  1: IconRankAwardGold,
  2: IconRankAwardSilver,
  3: IconRankAwardBronze,
};

const rankFillClasses = {
  1: "[&_path]:fill-[#9a7a19]",
  2: "[&_path]:fill-[#9a9a9a]",
  3: "[&_path]:fill-[#9a624b]",
};

interface RankBadgeProps {
  rank: number;
}

const RankBadge = ({ rank }: RankBadgeProps) => {
  const normalizedRank = Number(rank);
  const RankIcon =
    rankIcons[normalizedRank as keyof typeof rankIcons] || IconRankAwardBlue;
  const fillClass =
    rankFillClasses[normalizedRank as keyof typeof rankFillClasses] || "";

  return (
    <span
      className="relative isolate inline-flex h-[30px] w-[30px] shrink-0 items-center justify-center"
      aria-label={`順位 ${normalizedRank}`}
    >
      <RankIcon
        aria-hidden="true"
        data-testid={`rank-badge-icon-${normalizedRank}`}
        className={`block h-full w-full shrink-0 ${fillClass}`}
      />
      <span className="absolute inset-0 z-10 flex items-center justify-center font-['Audiowide'] text-[12px] leading-none text-white">
        {normalizedRank}
      </span>
    </span>
  );
};

export default RankBadge;
